export default __webpack_public_path__ + "static/media/radiology.7dfddcb1.svg";